import styled from 'styled-components';
import { Input, Select, Button } from 'antd';

export const StyledFieldRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.space_3};
  align-items: flex-start;
  margin-bottom: ${({ theme }) => theme.spacing.space_2};
`;

export const StyledAddonSelect = styled(Select)`
  width: ${({ theme }) => theme.size.tiny};
  display: flex;
  flex-direction: row;

  .ant-select-selector {
    height: ${({ theme }) => theme.spacing.space_5} !important;
    padding-right: ${({ theme }) => theme.spacing.space_2} !important;
    padding-left: ${({ theme }) => theme.spacing.space_2} !important;
  }
`;

export const StyledInput = styled(Input)`
  width: 100%;
  height: ${({ theme }) => theme.spacing.space_5};
  margin-top: ${({ theme }) => theme.spacing.space_2};
`;

export const StyledRemoveButton = styled(Button)`
  margin-bottom: ${({ theme }) => theme.spacing.space_2};
  align-self: center;
`;
